import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-writing-test',
  templateUrl: './writing-test.component.html',
  styleUrls: ['./writing-test.component.css']
})
export class WritingTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
